/*
  This page includes code adapted from OpenAI's ChatGPT language model.
  Original author: OpenAI
  Source: https://openai.com
*/

import React, { useState, useEffect } from 'react';
import NavBar from '../components/NavBar';
import './../styles.css';

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newContact, setNewContact] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    title: '',
    phoneNumber: '',
    email: '',
  });
  const [emptyFieldsError, setEmptyFieldsError] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');
  let url;

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      url = `${process.env.REACT_APP_SRV_BASE_URL}/api/contacts/user/${userId}`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setContacts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching contacts:', error);
      setContacts([]);
    }
  };

  const sendDataToBackend = async (data) => {
    const payload = { ...data, userId };

    try {
      const response = await fetch(`${process.env.REACT_APP_SRV_BASE_URL}/api/contacts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });
      const responseData = await response.json();
      if (response.ok) {
        fetchContacts();
      } else {
        console.error('Error in backend response:', responseData);
      }
    } catch (error) {
      console.error('Error sending data to backend:', error);
    }
  };

  const updateContactInBackend = async (contact) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SRV_BASE_URL}/api/contacts/${contact._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(contact),
      });
  
      if (response.ok) {
        fetchContacts();
      } else {
        const responseData = await response.json();
        console.error('Error in backend response:', responseData);
      }
    } catch (error) {
      console.error('Error updating contact:', error);
    }
  };

  const deleteContactFromBackend = async (contactId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_SRV_BASE_URL}/api/contacts/${contactId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.ok) {
            fetchContacts();
        } else {
            const responseData = await response.json();
            console.error('Error in backend response:', responseData);
        }
    } catch (error) {
        console.error('Error deleting contact:', error);
    }
};

  const handleAddContact = (e) => {
    e.preventDefault();

    const emptyFields = ['firstName', 'lastName', 'companyName', 'title'].some((field) => newContact[field].trim() === '');
    
    if (emptyFields) {
      setEmptyFieldsError(true);
      return;
    }

    if (isUpdateMode) {
      const updatedContacts = contacts.map((contact) =>
        contact._id === selectedContact._id ? newContact : contact
      );
      setContacts(updatedContacts);
      updateContactInBackend(newContact);
      setShowModal(false);
      resetForm();
      setNewContact({
        firstName: '',
        lastName: '',
        companyName: '',
        title: '',
        phoneNumber: '',
        email: '',
      });
      setEmptyFieldsError(false);
      setIsUpdateMode(false);
      setSelectedContact(null);
    } else {
      setContacts([...contacts, newContact]);
      sendDataToBackend(newContact);
      setShowModal(false);
      resetForm();
      setNewContact({
        firstName: '',
        lastName: '',
        companyName: '',
        title: '',
        phoneNumber: '',
        email: '',
      });
      setEmptyFieldsError(false);
    }
  };

  const handleDeleteContact = (id) => {
    const updatedContacts = contacts.filter((contact) => contact._id !== id);
    setContacts(updatedContacts);
    deleteContactFromBackend(id);
  };

  const handleUpdateContact = (contact) => {
    setShowModal(true);
    setIsUpdateMode(true);
    setSelectedContact(contact);
    setNewContact(contact);
  };

  const resetForm = () => {
    setNewContact({
      firstName: '',
      lastName: '',
      companyName: '',
      title: '',
      phoneNumber: '',
      email: '',
    });
    setEmptyFieldsError(false);
    setIsUpdateMode(false);
    setSelectedContact(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewContact({ ...newContact, [name]: value });
  };

  return (
    <div>
      <NavBar />
      <div className="center">
        <button className="btn btn-primary mt-3 btn-add-contact mobile-margin-bottom" onClick={() => { resetForm(); setShowModal(true); }}>
          Add Contact
        </button>
      </div>

      {contacts.length > 0 && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Company Name</th>
                <th>Title</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <tr key={contact._id}>
                  <td>{contact.firstName}</td>
                  <td>{contact.lastName}</td>
                  <td>{contact.companyName}</td>
                  <td>{contact.title}</td>
                  <td>{contact.phoneNumber}</td>
                  <td>{contact.email}</td>
                  <td>
                    <button className="btn btn-update ml-1" onClick={() => handleUpdateContact(contact)}>
                      Update
                    </button>
                    <button className="btn btn-danger" onClick={() => handleDeleteContact(contact._id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => { resetForm(); setShowModal(false); }}>
              &times;
            </span>
            <h2>{isUpdateMode ? 'Update Contact' : 'Add Contact'}</h2>
            <form onSubmit={handleAddContact}>
              <div>
                <label>First Name:</label>
                <input type="text" name="firstName" value={newContact.firstName} onChange={handleInputChange} required />
              </div>
              <div>
                <label>Last Name:</label>
                <input type="text" name="lastName" value={newContact.lastName} onChange={handleInputChange} required />
              </div>
              <div>
                <label>Company Name:</label>
                <input type="text" name="companyName" value={newContact.companyName} onChange={handleInputChange} required />
              </div>
              <div>
                <label>Title:</label>
                <input type="text" name="title" value={newContact.title} onChange={handleInputChange} required />
              </div>
              <div>
                <label>Phone Number:</label>
                <input type="text" name="phoneNumber" value={newContact.phoneNumber} onChange={handleInputChange} />
              </div>
              <div>
                <label>Email:</label>
                <input type="email" name="email" value={newContact.email} onChange={handleInputChange} />
              </div>
              {emptyFieldsError && <p className="error-message">Please fill out all required fields</p>}
              <div className="center">
                <button type="submit" className="btn btn-primary mt-1">
                  {isUpdateMode ? 'Update' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contacts;
